import { useQuery } from "@tanstack/react-query";
import type { ManualSearchResult } from "@arc/contracts";
import type { AuthSession } from "../../auth/keycloak.js";
import { favoriteApi } from "../../api/client.js";

/**
 * The caller's favourite manuals as FULL cards (`GET /user/manual-favourites/list`, ADR-011) — powers the drill-down's
 * global "Manual favourites" rail. Unlike {@link useManualFavorites} (an ids-only Set for the in-facility star), the
 * drill-down has no manuals loaded, so this returns the manual's card fields + facility location (same DTO as search),
 * permission-filtered server-side to active, directly-viewable manuals. Keyed per tenant + subject; the in-facility
 * toggle invalidates this key so the count/list stay fresh across the round-trip.
 */
export function useManualFavouritesList(session: AuthSession | null) {
  return useQuery({
    queryKey: ["manual-favourites-list", session?.realm, session?.sub],
    enabled: session !== null,
    queryFn: async (): Promise<ManualSearchResult[]> => {
      const res = await favoriteApi.listUserManualFavouritesDetailed();
      if (res.status !== 200) throw new Error(`GET /user/manual-favourites/list returned ${res.status}`);
      return res.body.results;
    },
  });
}
